import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex-grow"
}


import { defineComponent, defineProps } from 'vue'
import { getI18n } from '../utils'
// 解决vs中的语法错误提示
const __default__ = defineComponent({
  name: 'MenuItemRender'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  item: Object
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_MenuItemRender = _resolveComponent("MenuItemRender", true)!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!

  return ((__props.item.icon !=='' && __props.item.icon !== undefined && __props.item.icon != null) || __props.item.tag == 'el-icon-menu-item')
    ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 0,
        index: __props.item.id
      }, {
        title: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(__props.item.icon)))
            ]),
            _: 1
          }),
          _createElementVNode("span", null, _toDisplayString(_unref(getI18n)(__props.item.label)), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, (subItem) => {
            return (_openBlock(), _createBlock(_component_MenuItemRender, {
              item: subItem,
              key: subItem.id
            }, null, 8, ["item"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["index"]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (__props.item.tag == 'el-menu-item')
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 0,
              index: __props.item.id
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getI18n)(__props.item.label)), 1)
              ]),
              _: 1
            }, 8, ["index"]))
          : (__props.item.tag == 'menu-placeholder')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1))
            : (_openBlock(), _createBlock(_component_el_sub_menu, {
                key: 2,
                index: __props.item.id
              }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getI18n)(__props.item.label)), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, (subItem) => {
                    return (_openBlock(), _createBlock(_component_MenuItemRender, {
                      item: subItem,
                      key: subItem.id
                    }, null, 8, ["item"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["index"]))
      ], 64))
}
}

})